import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { withAITracking } from "@microsoft/applicationinsights-react-js";

import { ai } from "./createApplicationInsights";

const ApplicationInsights = ({ history, instrumentationKey, children }) => {
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (!initialized && instrumentationKey && history) {
      ai.initialize(instrumentationKey, history);
      setInitialized(true);
    }
  }, []);

  return children;
};

ApplicationInsights.propTypes = {
  instrumentationKey: PropTypes.string,
  history: PropTypes.shape({}).isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default withAITracking(ai.reactPlugin, ApplicationInsights);
